<template>
  <span></span>
</template>

<script>
export default {
  name: "Main",

  created() {
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    ) {
      this.$vuetify.theme.dark = true;
    } else {
      this.$vuetify.theme.dark = false;
    }
    this.$vuetify.lang.current = "fr";
    this.$router.push("/welcome");
  }
};
</script>
